import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { NotificationPreviewRequestType } from 'app/library/module/enums/notification-preview-request-type';
import { INotificationPrevieQuery } from 'app/library/module/interfaces/notification-preview.query.interface';
import { ModuleApiService } from 'app/library/module/services/module.api-service';
import { SectionApiService } from 'app/library/section/services/section-api.service';
import { ToDoTypeEnum } from 'app/library/to-do/enums/to-do-type.enum';
import { UserService } from 'app/library/user/services/user.service';
import { User } from 'app/projects/user/src/lib/models/user';

@Component({
    selector: 'app-notification-preview-dialog',
    templateUrl: './notification-preview-dialog.component.html',
    styleUrls: ['./notification-preview-dialog.component.scss'],
})
export class NotificationPreviewDialogComponent implements OnInit {
    @Input()
    moduleId: string;

    @Input()
    sectionId: string;

    @Input()
    entity: 'module' | 'section';

    @Input()
    title: string;

    @Input()
    description: string;

    @Input()
    notificationPreviewRequestType: NotificationPreviewRequestType;

    @Output()
    removedDueDate = new EventEmitter<boolean>();

    notificationPreview: INotificationPrevieQuery;
    isLoading: boolean = false;
    ToDoTypeEnum = ToDoTypeEnum;
    profile: User;
    logoSrc: string;
    translatableMessageProperties = {};
    NotificationPreviewRequestType = NotificationPreviewRequestType;

    constructor(
        public dialogRef: MatDialogRef<NotificationPreviewDialogComponent>,
        private _moduleAPiService: ModuleApiService,
        private _userService: UserService,
        private _tenantDataService: TenantDataService,
        private _translateService: TranslateService,
        private _sectionApiService: SectionApiService
    ) {}

    async ngOnInit(): Promise<void> {
        this.profile = this._userService.getMyInfo();
        this.logoSrc = this._tenantDataService.logo;

        this.isLoading = true;

        if (this.entity === 'module') {
            this.notificationPreview = await this._moduleAPiService.getModuleNotificationPreview(this.moduleId, this.notificationPreviewRequestType);
        } else if (this.entity === 'section') {
            this.notificationPreview = await this._sectionApiService.getSectionNotificationPreview(this.sectionId, this.notificationPreviewRequestType);
        }

        if (this.notificationPreview?.feed_item) {
            this.notificationPreview.feed_item.message_parameters.forEach((item) => {
                const key = item.key;
                let value: string;

                if (item.value) {
                    value = this._translateService.instant(item.value);
                } else {
                    value = item.value;
                }

                this.translatableMessageProperties[key] = value;
            });
        }

        this.isLoading = false;
    }

    removeDueDate(): void {
        this.removedDueDate.emit(true);
    }
}
